import React, { useState } from "react";
import styled from "styled-components";
import { putUpdateAvatar } from "api";
import cx from "classnames";
import avatarList from "config/avatarList";

const StyledAvartarPopup = styled.div`
  z-index: 100;
  & .popup-bg {
    position: relative;
    box-sizing: border-box;
    width: 300px;
    height: 267px;
    border-radius: 8px;
    padding: 38px 36px 8px;
    background-color: #fff;

    & .avatar-list {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    & .button {
      cursor: pointer;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 45px;
      border-radius: 0 0 8px 8px;
      background-image: linear-gradient(99deg, #fbc500, #ef7a00 100%);
    }
  }
`;
const AvatarItem = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 28px;
  margin-bottom: 16px;
  background-color: #000;
  background: url(${(props) => props.img}) no-repeat center center;
  background-size: cover;
  cursor: pointer;
  & .select-mark {
    position: absolute;
    right: -4px;
    top: -4px;
    color: #50c577;
    background: #fff;
    font-size: 17px;
    border-radius: 100%;
  }
  & .avatar-mask {
    width: 100%;
    height: 100%;
    background: url("images/avatar_mask.png") no-repeat left center;
    background-size: cover;
    &.select {
      background: url("images/avatar_mask.png") no-repeat right center;
      background-size: cover;
    }
    &.user {
      background: url("images/avatar_mask.png") no-repeat center center;
      background-size: cover;
    }
  }
`;
const AvatarPopup = ({ t, avatarPopHandler, userAvatar, dispatch }) => {
  const [userSelect, setUserSelect] = useState();
  const sendHandler = () => {
    avatarPopHandler();
    putUpdateAvatar({ avatar: userSelect }, dispatch);
  };

  const selectHandler = (id) => {
    setUserSelect(id);
  };
  return (
    <StyledAvartarPopup>
      <div className="popup-bg">
        <div className="avatar-list">
          {avatarList.map((v) => (
            <AvatarItem
              key={v.get("id")}
              img={v.get("avatar")}
              onClick={() => {
                selectHandler(v.get("id"));
              }}
            >
              <div
                className={cx([
                  "avatar-mask",
                  {
                    user: v.get("id") === userAvatar,
                    select: v.get("id") === userSelect,
                  },
                ])}
              />
              {v.get("id") === userAvatar && (
                <div className="bx bxs-check-circle select-mark" />
              )}
            </AvatarItem>
          ))}
        </div>
        <div
          className="button gav2_avatar"
          ga-avatarid={userSelect || userAvatar}
          onClick={sendHandler}
        >
          {t("send")}
        </div>
      </div>
    </StyledAvartarPopup>
  );
};

export default AvatarPopup;
